import { getIn } from '../helpers/helpers';
import { getAction, getConfigItemByKey, getTrigger, getTriggerConfigItemByKey } from './available_steps';
import { getStepKeyPathById } from './helpers';
import { getAvailableActionsFromMetadata } from './StepMetadata';
import { WorkflowEditorState, WorkflowStep } from './workflow-types';

export const validateStepConfigValue = (state: WorkflowEditorState, step, propName: string) => {
  const availableActions = getAvailableActionsFromMetadata(state.publishedApps);
  const action = getAction(availableActions, step);
  const actionConfigItem = action ? getConfigItemByKey(action, propName) : null;
  if (actionConfigItem && actionConfigItem.required) {
    const propValue = step.config[propName];
    const hasError = !propValue;
    state.errorState[propName] = hasError;
  }
};

export const validateTriggerConfigValue = (state: WorkflowEditorState, trigger, propName) => {
  const availableActions = getAvailableActionsFromMetadata(state.publishedApps);
  const triggerListItem = getTrigger(availableActions, trigger);
  const triggerConfigItem = triggerListItem && trigger ? getTriggerConfigItemByKey(triggerListItem, propName) : null;
  if (triggerConfigItem && triggerConfigItem.required) {
    const propValue = trigger[propName];
    const hasError = !propValue;
    state.errorState[propName] = hasError;
  }
};

export const updatePropertyErrorState = (state: WorkflowEditorState, payload) => {
  const selectedStepId = state.selectedStepId;
  const selectedTrigger = state.selectedTrigger;
  const keyName = payload.propKeyPath[payload.propKeyPath.length - 1];
  if (selectedStepId) {
    const selectedStepKeyPath = getStepKeyPathById(state, selectedStepId);
    const step = getIn<WorkflowStep>(state, selectedStepKeyPath);
    validateStepConfigValue(state, step, keyName);
  } else if (selectedTrigger) {
    const trigger = state.workflow.trigger;
    validateTriggerConfigValue(state, trigger, keyName);
  }
};

export const updateStepErrorState = (state: WorkflowEditorState) => {
  const selectedStepId = state.selectedStepId;
  const selectedTrigger = state.selectedTrigger;
  state.errorState = {};
  if (selectedStepId) {
    const selectedStepKeyPath = getStepKeyPathById(state, selectedStepId);
    const step = getIn<WorkflowStep>(state, selectedStepKeyPath);
    for (const configItemKey of Object.keys(step.config)) {
      validateStepConfigValue(state, step, configItemKey);
    }
  } else if (selectedTrigger) {
    const trigger = state.workflow.trigger;
    for (const triggerProp of Object.keys(trigger)) {
      validateTriggerConfigValue(state, trigger, triggerProp);
    }
  }
};
